import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdf4034e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sr-only" }, "Resell your tickets with Tixel", -1))
const _hoisted_2 = { class: "resell-your-ticket" }
const _hoisted_3 = {
  class: "oztix-love-tixel",
  "aria-hidden": "true"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Sell your Oztix tickets with our resale partner, "),
    /*#__PURE__*/_createElementVNode("strong", null, "Tixel!")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "The safest way to resell tickets to any event you can’t make."),
  /*#__PURE__*/_createElementVNode("p", null, " Through our collaboration with Tixel, you can list any kind of Oztix ticket for resale to another customer. Music, festivals, theatre, concerts, parties, exhibitions, sporting events, conferences, you name it! Tixel is the safest and easiest place to buy and sell tickets online. "),
  /*#__PURE__*/_createElementVNode("p", null, "Only real tickets for real fans."),
  /*#__PURE__*/_createElementVNode("a", {
    class: "secondary-button",
    href: "https://tixel.com/sell/Oztix"
  }, "Resell my ticket")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_heart = _resolveComponent("icon-heart")!
  const _component_compact_layout = _resolveComponent("compact-layout")!

  return (_openBlock(), _createBlock(_component_compact_layout, { full: true }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("section", {
        class: "resell-your-ticket-bg",
        style: _normalizeStyle({
        'background-image': `url(${require('@/assets/resell/pattern-festival-phone-bg.jpg')})`,
      })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/oztix-logo.svg')
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_icon_heart, {
                class: "heart",
                filled: true
              })
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: require('@/assets/tixel-white.svg')
              }, null, 8, _hoisted_5)
            ])
          ]),
          _hoisted_6
        ])
      ], 4)
    ]),
    _: 1
  }))
}